import { atQuery } from '../scripts/components/mediaQueries';

export const camelize = function (str) {
  let arr = str.split('-');
  let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item);
  // ^-- change here.
  let capitalString = capital.join("");
  return capitalString;
}

export const dependenciesCheck = function () {
  var passed = true;

  for (var i = 0; i < arguments.length; i++) {
    var argBooleanValue = !!(typeof arguments[i] === 'string' || arguments[i] instanceof jQuery ? arguments[i].length : arguments[i]);
    passed = (passed && argBooleanValue);
  }

  return passed;
};

export const isTouchDevice = function () {
  return (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
};

export const calculateTopMenu = function (mobileMediaQuery, menuContainer, menuContainerDesktop) {

  if (!menuContainer) {
    return;
  }

  menuContainer.style.top = headerHeight() + 'px';

  if (menuContainerDesktop && mobileMediaQuery) {
    menuContainerDesktop.style.top = headerHeight() + 'px';
    atQuery('min', mobileMediaQuery, () => {
      menuContainer.style.top = 'initial';
    });
  }
}

/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 *`{leading: false}`. To disable execution on the trailing edge, ditto.
 * @param func
 * @param wait
 * @param options
 * @returns {function(): *}
 */
export const throttle = function (func, wait, options) {
  var context, args, result
  var timeout = null
  var previous = 0
  if (!options) options = {}
  var later = function () {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function () {
    var now = Date.now()
    if (!previous && options.leading === false) previous = now
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

export const announcementBarHeight = () => {
  const announcementBar = document.querySelector('.announcement-bar')
    ? document.querySelector('.announcement-bar')
    : document.querySelector('#FreeShippingBanner');
  if (announcementBar) {
    return announcementBar.clientHeight;
  } else {
    return 0;
  }
}

export const headerHeight = function () {
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const header = siteHeader.querySelector('.header__container');
    if (header && !header.classList.contains('header__transparent')) {
      if (siteHeader.classList.contains('headroom--unpinned')) {
        return header.clientHeight;
      } else {
        return header.clientHeight + announcementBarHeight();
      }
    } else {
      if (siteHeader.classList.contains('headroom--unpinned')) {
        return 0;
      } else {
        return announcementBarHeight();
      }
    }
  } else {
    return 0;
  }
}

export const fullHeaderHeight = function () {
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    const header = siteHeader.querySelector('.header__container');
    if (header) {
      if (siteHeader.classList.contains('headroom--unpinned')) {
        return header.clientHeight;
      } else {
        return header.clientHeight + announcementBarHeight();
      }
    } else return announcementBarHeight();
  } else return 0;
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  if (exdays == undefined) {
    exdays = 1;
  }
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function isAppleDevice() {
  const ua = navigator.userAgent;
  const platform = navigator.platform;

  // Verifica iOS (iPhone, iPad, iPod)
  const isIOS = /iPhone|iPad|iPod/i.test(ua) && !window.MSStream;

  // Verifica macOS (macintosh oppure Mac Intel)
  const isMac = /Macintosh|MacIntel/.test(platform);

  return isIOS || isMac;
}
